import React from 'react';
import { Loader2 } from 'lucide-react';

interface SessionCheckScreenProps {
  /** The server gives no answer yet; the check keeps trying on its own. */
  serverUnreachable?: boolean;
}

/**
 * Shown for the moment a freshly opened tab needs to learn whether someone is
 * signed in. Deciding before that sent every signed-in user to the login form.
 */
const SessionCheckScreen: React.FC<SessionCheckScreenProps> = ({ serverUnreachable = false }) => (
  <div
    className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background px-6 text-center"
    role="status"
    aria-live="polite"
    aria-label="Anmeldung wird geprüft"
  >
    <Loader2 className="h-8 w-8 animate-spin text-muted-foreground/70" aria-hidden="true" />
    {serverUnreachable && (
      <p className="max-w-sm text-sm text-muted-foreground">
        Der Server ist gerade nicht erreichbar. Sie bleiben angemeldet – wir versuchen es weiter.
      </p>
    )}
  </div>
);

export default SessionCheckScreen;
